import DatePicker from 'material-ui/DatePicker';
import RaisedButton from 'material-ui/RaisedButton';
import { Step, StepLabel, Stepper } from 'material-ui/Stepper';
import ArrowForwardIcon from 'material-ui/svg-icons/navigation/arrow-forward';
import TextField from 'material-ui/TextField';
import React, { Component } from 'react';
import Recaptcha from 'react-recaptcha';
import { connect } from 'react-redux';
import {
    withRouter
} from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import * as actions from '../../actions/actions.jsx';
import answerimg from '../../images/answer.png';
import service from '../../services//allservices.jsx';
// import Input from '@material-ui/core/Input';
import LoaderSmall from "../loader/loadersmall.jsx";
import GusetNavbar from '../navigation/guestnavbar.jsx';
import DefaulNavbar from '../navigation/defaultnavbar.jsx';
import { getClientId, getClientSecret, buildClientHeader } from "../../../src/utils/clientAuth.js";
import uuidv4 from 'uuid/v4';
import SuccessPopup from '../secretqbutton/secretqbutton.jsx';
// import Input from 'material-ui/core/Input';
// import InputLabel from 'material-ui/core/InputLabel';
// import FormHelperText from 'material-ui/core/FormHelperText';
// import FormControl from 'material-ui/core/FormControl';
import OtpPopup from '../otp/OtpPopup.js';

const mapStateToProps = state =>
({
    publicKey: state.publicKey.publicKey,
    passwordState: state.getPasswordReducer.passwordState

})
const mapDispatchToProps = dispatch =>
({
    fetchPassword(userid) {
        dispatch(
            actions.getPasswordAction(userid)
        )
    },

})

const styles = {
    button: {
        margin: 12,
        background: "#2a5194"
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    }
};
var callback = function () {

};

// specifying verify callback function

let recaptchaInstance;
const resetRecaptcha = () => {
    recaptchaInstance.reset()
}
const JSEncrypt = window.JSEncrypt
class ForgotPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stepIndex: 0,
            response: "",
            userId: '',
            secretPassword: '',
            secretQuestionCode: '',
            accountId: '',
            answer: '',
            correctpass: true,
            applicationId: '',
            disabled: true,
            disabledpass: true,
            checked: false,
            publickey: "",
            showResetPopup: false,
            popupMessage: "",
            otpOpen: false,
            otp: "",
            popupLoader: false,


        }
        this.otpPopupOpenModal = this.otpPopupOpenModal.bind(this);
        this.otpPopupCloseModal = this.otpPopupCloseModal.bind(this);
    }
    handleGoback(e) {
        // localStorage.clear();
        // this.props.history.push("/login")
        const pform = localStorage.getItem("pform");

        localStorage.clear();

        if (pform) {
            localStorage.setItem("pform", pform);
        }

        this.props.history.push("/login");
    }
    componentDidmount() {



    }

    // for otp open


    otpPopupOpenModal() {
        if (!this.state.otpValidation) {
            // Skip OTP — call final API directly
            this.setState({ otp: "", popupLoader: true }, () => {
                this.getPassword(
                    this.props.passwordState.body.accountId,
                    this.props.passwordState.body.secretQuestionCode,
                    null,
                    null
                );
            });
            return;
        }

        this.setState({
            otpOpen: true,
        }, () => {
            this.handleRequestOtp(false);
        });
    }

    // for otp close
    otpPopupCloseModal() {

        this.setState({
            otpOpen: false,
        });
    }
    handleRequestOtp = (isResend = false) => {

        const { passwordState, publicKey } = this.props;

        const accountId = passwordState.body.accountId;

        if (publicKey && publicKey.status === 200) {

            const public_Key = publicKey.body.publickey;

            let encrypt = new JSEncrypt();

            encrypt.setPublicKey(public_Key);

            let traceId = getClientId();

            let gid = getClientId();

            const payload = {

                accountId: encrypt.encrypt(accountId),

                applicationId:
                    localStorage.getItem("pform") === "AU"
                        ? "klickexau"
                        : "klickex"
            };
            if (isResend) {
                payload.reSendOtp = true;
            }
            this.setState({
                loader: true
            });

            let plink =
                localStorage.getItem("pform") === "AU"
                    ? process.env.REACT_APP_SERVICEURL_AU
                    : process.env.REACT_APP_SERVICEURL_NZ;

            fetch(plink + service.otp_forgot_password, {

                method: "POST",

                headers: new Headers({

                    "Content-Type": "application/json",

                    clientId: gid,

                    clientSecret: getClientSecret(gid, accountId),

                    "X-Trace-Id": traceId,

                    "X-KlickEx-Client": buildClientHeader(),
                }),

                body: JSON.stringify(payload)

            })
                .then((response) => {

                    if (
                        response.status === 200 ||
                        response.status === 201 ||
                        response.status === 204
                    ) {

                        toast.success(response.headers.get("message"), {

                            position: "top-right",
                            autoClose: 3000,
                        });

                    }
                    else if (response.status === 401) {

                        this.setState({
                            loader: false
                        });

                        if (this.props.history !== undefined) {
                            this.props.history.push('/sessionout')
                        }

                    }
                    else {

                        toast.error(response.headers.get("message"), {

                            position: "top-right",
                            autoClose: 3000,
                        });
                    }

                    this.setState({
                        loader: false
                    });

                    return response;
                });
        }
    };
    handleOtpSubmit = (otp, onSuccess, onError) => {

        this.setState({

            otp: otp,
            popupLoader: true,

        }, () => {

            this.getPassword(
                this.props.passwordState.body.accountId,
                this.props.passwordState.body.secretQuestionCode,
                onSuccess,
                onError
            );

        });

    };
    otpPopupCloseModal() {

        this.setState({
            otpOpen: false,
            popupLoader: false,
        });
    }
    handleText(e) {
        const userid = e.target.value
        this.setState({
            userId: userid
        }, () => {
            if (this.state.userId.length !== 0) {
                this.setState({
                    disabled: false
                })
            }
            else {
                this.setState({
                    disabled: true
                })
            }

        })



    }
    handelReset = () => {

    }
    verifyCallback = response => {

        this.setState({
            response: response,
        }, () => {
            if (this.state.secretPassword.length !== 0 && this.state.response.length !== 0) {
                this.setState({
                    disabledpass: false
                })
            }
            else {
                this.setState({
                    disabledpass: true
                })
            }


        })

    }
    expiredCallback = response => {
        this.setState({
            disabledpass: true
        })

    }
    handleDate = (e, date) => {
        this.setState({
            secretPassword: this.converDate(date),
            dateSelected: true,
            disabledpass: false
        })
    }
    converDate(date) {
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();

        return [date.getFullYear(),
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd
        ].join('-');
    }
    formatDate = (date) => {
        let day = date.getDate()
        let month = date.getMonth() + 1
        let year = date.getFullYear()
        return `${(day < 10) ? ('0' + day) : day}/${(month < 10) ? ('0' + month) : month}/${year}`
    }
    handleAnswer(e, value) {
        const answer = e.target.value
        // const {response} =this.state
        this.setState({
            secretPassword: answer
        }, () => {
            if (this.state.secretPassword.length !== 0 && this.state.response.length !== 0) {
                this.setState({
                    disabledpass: false
                })
            }
            else {
                this.setState({
                    disabledpass: true
                })
            }
        })
    }

    getPassword(accountid, secretQuestionCode, onSuccess, onError) {

        const { response, correctpass } = this.state
        const { publicKey } = this.props
        this.setState({ disabledpass: true })
        if (correctpass === false) {
            this.setState({
                correctpass: false,
            })
        }


        let _this = this
        if (response !== '') {

            if (publicKey && publicKey.status === 200) {

                const public_Key = publicKey && publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);

                const state = {
                    accountId: encrypt.encrypt(accountid),
                    applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                    secretPassword: encrypt.encrypt(this.state.secretPassword),
                    secretQuestionCode: encrypt.encrypt(secretQuestionCode),
                    otp: this.state.otp
                }
                this.setState({
                    loader: true
                })
                let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
                let gid = getClientId();
                let traceId = getClientId();
                const accountId = JSON.parse(localStorage.getItem("passwordState")).body.accountId
                fetch(plink + service.forgot_password + "/?g-recaptcha-response=" + response, {
                    credentials: "same-origin",
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'clientId': gid,
                        'clientSecret': getClientSecret(gid, accountId),
                        'X-Trace-Id': traceId,
                        'X-KlickEx-Client': buildClientHeader(),

                    }),
                    body: JSON.stringify(state)
                })
                    // .then(response => {
                    //     if (response.status === 200 || response.status === 201 || response.status === 204) {

                    //         toast.success(response.headers.get('message'), {
                    //             position: "top-right",
                    //             draggablePercent: 60,
                    //             autoClose: 3000,
                    //             hideProgressBar: false,
                    //             closeOnClick: true,
                    //             pauseOnHover: true,
                    //             draggable: false
                    //         });
                    //         if (onSuccess) {
                    //             onSuccess();
                    //         }

                    //         this.otpPopupCloseModal();

                    //         this.setState({
                    //             popupLoader: false,
                    //         });
                    //         setTimeout(function () {
                    //             _this.props.history.push('/');
                    //         }, 3000);

                    //     }
                    //     else if (response.status === 401) {

                    //         this.setState({
                    //             popupLoader: false,
                    //             loader: false,
                    //             disabledpass: true
                    //         });

                    //         this.otpPopupCloseModal();

                    //         if (this.props.history !== undefined) {
                    //             this.props.history.push('/sessionout')
                    //         }

                    //     }
                    //     //    else if (response.status === 422) {

                    //     //                                         this.setState({
                    //     //                                             popupLoader: false,
                    //     //                                             loader: false,
                    //     //                                         });
                    //     //                                         if (onError) {
                    //     //                                             onError(response.headers.get('message'));
                    //     //                                         }
                    //     //                                         let message = response.headers.get("message");

                    //     //                                         response.json().then((json) => {
                    //     //                                         message = json.message
                    //     //                                             ? json.message
                    //     //                                             : response.headers.get("message");

                    //     //                                         toast.error(message, {
                    //     //                                             position: "top-right",
                    //     //                                             autoClose: 3000,
                    //     //                                             hideProgressBar: false,
                    //     //                                             closeOnClick: true,
                    //     //                                             pauseOnHover: true,
                    //     //                                             draggable: true,
                    //     //                                             draggablePercent: 60,
                    //     //                                         });
                    //     //                                         });

                    //     //                                         // toast.error(message, {
                    //     //                                         //     position: "top-right",
                    //     //                                         //     autoClose: 3000,
                    //     //                                         //     hideProgressBar: false,
                    //     //                                         //     closeOnClick: true,
                    //     //                                         //     pauseOnHover: true,
                    //     //                                         //     draggable: true,
                    //     //                                         //     draggablePercent: 60,
                    //     //                                         // });

                    //     //                                     }
                    //     else if (response.status === 422) {
                    //         // resetRecaptcha()
                    //         // this.otpPopupCloseModal();
                    //         this.setState({
                    //             popupLoader: false,
                    //             loader: false,
                    //         });
                    //         if (onError) {
                    //             onError(response.headers.get('message'));
                    //         }
                    //         let message = response.headers.get("message");

                    //         response.json()
                    //             .then((json) => {
                    //                 if (json && json.message) {
                    //                     message = json.message;
                    //                 }
                    //                 toast.error(message, {
                    //                     position: "top-right",
                    //                     autoClose: 3000,
                    //                     hideProgressBar: false,
                    //                     closeOnClick: true,
                    //                     pauseOnHover: true,
                    //                     draggable: true,
                    //                     draggablePercent: 60,
                    //                 });
                    //             })
                    //             .catch(() => {
                    //                 toast.error(message, {
                    //                     position: "top-right",
                    //                     autoClose: 3000,
                    //                     hideProgressBar: false,
                    //                     closeOnClick: true,
                    //                     pauseOnHover: true,
                    //                     draggable: true,
                    //                     draggablePercent: 60,
                    //                 });
                    //             });

                    //     }

                    //     else {
                    //         this.setState({
                    //             popupLoader: false,
                    //             loader: false
                    //         });

                    //         if (onError) {
                    //             onError(response.headers.get('message'));
                    //         }
                    //         // toast.error(response.headers.get('message'), {
                    //         //     position: "top-right",
                    //         //     draggablePercent: 60,
                    //         //     autoClose: 3000,
                    //         //     hideProgressBar: false,
                    //         //     closeOnClick: true,
                    //         //     pauseOnHover: true,
                    //         //     draggable: false
                    //         // });
                    //           let message = response.headers.get("message");
                    //         response.json().then((json) => {
                    //         message = json.message
                    //             ? json.message
                    //             : response.headers.get("message");
                       
                    //         toast.error(message, {
                    //             position: "top-right",
                    //             autoClose: 3000,
                    //             hideProgressBar: false,
                    //             closeOnClick: true,
                    //             pauseOnHover: true,
                    //             draggable: true,
                    //             draggablePercent: 60,
                    //         });
                    //         });
                    //         this.setState({
                    //             loader: false
                    //         })
                    //         // setTimeout(function () { window.location.reload(true); }, 2000);

                    //     }



                    //     resetRecaptcha()
                    //     this.otpPopupCloseModal();


                    // })
                    .then(response => {
    if (response.status === 200 || response.status === 201 || response.status === 204) {

        toast.success(response.headers.get('message'), {
            position: "top-right",
            draggablePercent: 60,
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false
        });
        if (onSuccess) {
            onSuccess();
        }

        this.otpPopupCloseModal();

        this.setState({
            popupLoader: false,
        });
        setTimeout(function () {
            _this.props.history.push('/');
        }, 3000);

    }
    else if (response.status === 401) {

        this.setState({
            popupLoader: false,
            loader: false,
            disabledpass: true
        });

        this.otpPopupCloseModal();

        if (this.props.history !== undefined) {
            this.props.history.push('/sessionout')
        }

    }
    else if (response.status === 422) {
        // resetRecaptcha()
        // this.otpPopupCloseModal();
        this.setState({
            popupLoader: false,
            loader: false,
        });
        if (onError) {
            onError(response.headers.get('message'));
        }
        let message = response.headers.get("message");

        response.json()
            .then((json) => {
                if (json && json.message) {
                    message = json.message;
                }
                toast.error(message, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    draggablePercent: 60,
                });
            })
            .catch(() => {
                toast.error(message, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    draggablePercent: 60,
                });
            });

    }

    else {
        this.setState({
            popupLoader: false,
            loader: false
        });

        if (onError) {
            onError(response.headers.get('message'));
        }
        let message = response.headers.get("message");
        response.json().then((json) => {
            message = json.message
                ? json.message
                : response.headers.get("message");

            toast.error(message, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 60,
            });
        });
        this.setState({
            loader: false
        });

        resetRecaptcha();
        this.otpPopupCloseModal();
        // setTimeout(function () { window.location.reload(true); }, 2000);

    }

})
            }

        }

    }
    handleContinue(e) {
        this.props.history.push('/setuserid')
    }
    checkObject(obj) {
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                return true;
            } else {
                return false
            }

        }
    }
    getStepContent(stepIndex) {
        const { passwordState } = this.props

        const { correctpass } = this.state
        switch (stepIndex) {
            case 0:
                return (
                    <div>
                        <div className="container">
                            <div className="row">
                                {this.state.otpOpen && (

                                    <OtpPopup
                                        open={this.state.otpOpen}
                                        onClose={this.otpPopupCloseModal}
                                        handleRequestOtp={this.handleRequestOtp}
                                        onSubmit={this.handleOtpSubmit}
                                        loading={this.state.popupLoader}
                                    />
                                )}
                                <ToastContainer
                                    draggablePercent={60}
                                    position="top-right"
                                    autoClose={3000}
                                    hideProgressBar={false}
                                    newestOnTop
                                    closeOnClick
                                    rtl={false}
                                    pauseOnVisibilityChange
                                    draggable={false}
                                    pauseOnHover
                                />
                                <div className="col-sm-12">
                                    <div className="col-sm-12">
                                        <div className="col-md-12" >
                                            <div className="row " style={{ padding: "12px 15px", minHeight: "100px" }} >
                                                <div>
                                                    <div className="row">
                                                        <div className="header-style" style={{ padding: "5px 20px 0px 15px" }}>
                                                            <h4 className='logmainheading mainheading'>
                                                                Forgot Your Password ?
                                                            </h4>
                                                            <p> Enter your User ID to retrieve your Password.  </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12" style={{ padding: "0px 15px", marginTop: "20px" }}>
                                            <div className="row  mb-3" style={{ padding: "12px 15px", minHeight: "300px" }} >
                                                <div className="summary-header">
                                                    <div className="row">
                                                        {/* <div className="col-md-12">
                                                            <p>Please Enter Your User ID</p>
                                                        </div> */}
                                                        <div className="col-md-12">

                                                            <div className="row" >
                                                                <div className="row input-group" >
                                                                    <div className="col-sm-10" >
                                                                        <TextField
                                                                            hintText="User ID"
                                                                            floatingLabelText="User ID"
                                                                            type="text"
                                                                            name="userid"
                                                                            // autoComplete='none'
                                                                            autoComplete='off'
                                                                            maxLength="20"
                                                                            className="my-className"
                                                                            underlineFocusStyle={styles.focusStyle}
                                                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                                                            onChange={this.handleText.bind(this)}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="row input-group text-center ml-1 mt-4">
                                                                    <RaisedButton
                                                                        label="Go Back To HomePage"
                                                                        // style={styles.button}
                                                                        className="btn-std mt-1 mr-3"
                                                                        backgroundColor="#FFCE39"
                                                                        labelColor="#115876"
                                                                        buttonStyle={{ borderRadius: 50 }}
                                                                        style={{ borderRadius: 50 }}
                                                                        onClick={this.handleGoback.bind(this)}
                                                                    // icon={<i className="fa fa-sign-in" aria-hidden="true" style={{ color: "#fff" }}></i>}
                                                                    />

                                                                    <RaisedButton
                                                                        label="Continue"
                                                                        // style={styles.button}
                                                                        className="mt-1 btn-std"
                                                                        backgroundColor="#FFCE39"
                                                                        labelColor="#115876"
                                                                        disabled={this.state.disabled}
                                                                        id="continuebtn"
                                                                        buttonStyle={{ borderRadius: 50 }}
                                                                        style={{ borderRadius: 50 }}
                                                                        onClick={this.handleNext.bind(this)}
                                                                    // icon={<i className="fa fa-sign-in" aria-hidden="true" style={{ color: "#fff" }}></i>}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            case 1:
                return (

                    <div>
                        {this.checkObject(passwordState) ?
                            <div className="row">
                                {this.state.otpOpen && (

                                    <OtpPopup
                                        open={this.state.otpOpen}
                                        onClose={this.otpPopupCloseModal}
                                        handleRequestOtp={this.handleRequestOtp}
                                        onSubmit={this.handleOtpSubmit}
                                        loading={this.state.popupLoader}
                                    />
                                )}
                                <ToastContainer
                                    draggablePercent={60}
                                    position="top-right"
                                    autoClose={3000}
                                    hideProgressBar={false}
                                    newestOnTop
                                    closeOnClick
                                    rtl={false}
                                    pauseOnVisibilityChange
                                    draggable={false}
                                    pauseOnHover
                                />
                                <div className="col-sm-12">

                                    <div className="col-sm-12">
                                        <div className="col-md-12">
                                            <div className="row " style={{ padding: "12px 15px", minHeight: "100px" }} >
                                                <div>
                                                    <div className="row">
                                                        <div className="header-style" style={{ padding: "5px 20px 0px 15px" }}>
                                                            <h4 className='logmainheading mainheading'>
                                                                Forgot Your Password ?
                                                            </h4>
                                                            <p>Complete the following security question to retrieve your password.  </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12" style={{ padding: "0px 15px", marginTop: "20px" }}>
                                            <div className="row  mb-3" style={{ padding: "12px 15px", minHeight: "100px" }} >
                                                <div>
                                                    <div className="row">
                                                        {/* <div className="col-md-12"> */}

                                                        {/* <div className="row" style={{ marginTop: "-25px" }}>                                                            <div className="row">
                                                                <div className="offset-md-1 col-md-10">
                                                                    <label className="col-md-4 nopadding">Secret Question: </label>
                                                                    <span className="col-md-6 nopadding">{passwordState.body.secretQuestionDescription + "?"}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div> */}
                                                        <div
                                                            className="row align-items-center"
                                                            style={{
                                                                marginTop: "-25px",

                                                                paddingLeft: "15px",
                                                            }}
                                                        >
                                                            <div className="col-md-12 d-flex flex-wrap align-items-center">
                                                                <label
                                                                    style={{
                                                                        fontWeight: "600",
                                                                        fontSize: "16px",
                                                                        marginRight: "10px",
                                                                        color: "#222",
                                                                        marginBottom: "0",
                                                                        minWidth: "140px",
                                                                    }}
                                                                >
                                                                    Secret Question:
                                                                </label>

                                                                <span
                                                                    style={{
                                                                        fontSize: "16px",
                                                                        color: "#444",
                                                                        wordBreak: "break-word",
                                                                    }}
                                                                >
                                                                    {passwordState.body.secretQuestionDescription}?
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <div className="col-md-12 pl-1" >
                                                                <div className="row input-group" >
                                                                    {/* <div className="offset-md-1 col-2 input-icon" >
                                                                        <img src={answerimg} alt="" />
                                                                    </div> */}
                                                                    <div className="offset-md-2 offset-sm-0 col-sm-5 flex d-flex"  >

                                                                        {(passwordState.body.secretQuestionCode === "DOB") ?

                                                                            <DatePicker hintText="Birthday"
                                                                                // container="inline" mode="landscape"
                                                                                openToYearSelection={true}
                                                                                floatingLabelText="Secret Answer(Date Of Birth)"
                                                                                style={{ width: "100%" }}
                                                                                type="text"
                                                                                name="secretAnswer"
                                                                                onChange={this.handleDate}
                                                                                id="secretAns"
                                                                                maxDate={new Date()}
                                                                                formatDate={this.formatDate}
                                                                                className="input-width required"
                                                                                // defaultValue={this.state.secretAnswerDate || null}
                                                                                // defaultDate={( new Date(this.state.secretAnswerDate))} 
                                                                                // defaultDate={ this.state.secretAnswerDate}
                                                                                defaultDate={(this.state.secretAnswerDate) ? new Date(this.state.secretAnswerDate) : this.state.secretAnswerDate}

                                                                                // defaultDate={new Date()}
                                                                                // defaultDate= {new Date()}
                                                                                underlineFocusStyle={styles.focusStyle}
                                                                                floatingLabelFocusStyle={styles.focusTextStyle} />
                                                                            :
                                                                            <TextField
                                                                                hintText={"Start Typing.."}
                                                                                floatingLabelText="Secret Answer"
                                                                                type="text"
                                                                                name="answer"
                                                                                style={{ width: "100%" }}
                                                                                id="secretAns"
                                                                                maxLength="50"
                                                                                className="my-className"
                                                                                underlineFocusStyle={styles.focusStyle}
                                                                                floatingLabelFocusStyle={styles.focusTextStyle}
                                                                                onChange={this.handleAnswer.bind(this)}
                                                                                errorText={correctpass ? null : "Please enter secert answer"}
                                                                            />

                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="offset-md-2 col-sm-7 offset-sm-0 text-center margin-capcha">
                                                                        <Recaptcha
                                                                            sitekey="6LeRorofAAAAACriDJ7aN2WI9LOCRz8aN2KzqU3C"
                                                                            render="explicit"
                                                                            verifyCallback={this.verifyCallback}
                                                                            expiredCallback={this.expiredCallback}
                                                                            onloadCallback={callback}
                                                                            ref={e => recaptchaInstance = e}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="row input-group" style={{ marginTop: "15px" }} >
                                                                    <div className="col-sm-12 offset-md-2 " >
                                                                        <label style={{ fontSize: "15px", color: "rgb(66, 62, 62)" }}>
                                                                            Password to be emailed to: {passwordState.body.emailId || "-"}
                                                                        </label>
                                                                    </div>

                                                                </div>
                                                                <div className="row offset-md-2 input-group text-center"  >

                                                                    <RaisedButton
                                                                        label="Go Back To HomePage"
                                                                        // style={styles.button}
                                                                        className="btn-std mt-2 mr-3"
                                                                        backgroundColor="#FFCE39"
                                                                        labelColor="#115876"
                                                                        onClick={this.handleGoback.bind(this)}
                                                                        buttonStyle={{ borderRadius: 50 }}
                                                                        style={{ borderRadius: 50 }}
                                                                    // icon={<i className="fa fa-sign-in" aria-hidden="true" style={{ color: "#fff" }}></i>}
                                                                    />
                                                                    <RaisedButton
                                                                        label="Get Password"
                                                                        className="mt-2 btn-std"
                                                                        backgroundColor="#FFCE39"
                                                                        labelColor="#115876"
                                                                        disabled={this.state.disabledpass}
                                                                        buttonStyle={{ borderRadius: 50 }}
                                                                        style={{ borderRadius: 50 }}
                                                                        // onClick={this.handleContinue.bind(this)}
                                                                        // icon={<i className="fa fa-sign-in" aria-hidden="true" style={{ color: "#fff" }}></i>}
                                                                        // onClick={(e) => { this.getPassword(passwordState.body.accountId, passwordState.body.secretQuestionCode) }}
                                                                        onClick={this.otpPopupOpenModal}
                                                                    />
                                                                    {this.state.loader === true &&
                                                                        <div className="col-sm-1" style={{ position: 'absolute', top: '-40%', left: '70%', width: "30% !mportant" }} >
                                                                            <LoaderSmall />
                                                                        </div>}
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> :
                            <div>
                            </div>}
                    </div>
                );
            default:
                return (
                    <div>Something Went Wrong</div>
                )
        }
    }
    sendUserDetail(userDetail) {
        this.setState({ stepIndex: 1, userDetailState: userDetail });
    }


    handleStepCount7() {

        const { passwordState } = this.props;
        const { stepIndex } = this.state;

        if (passwordState.status === 200) {
            localStorage.setItem('emailID', passwordState.body.emailId);
            this.setState({
                stepIndex: stepIndex + 1,
                otpValidation: passwordState.body.otpValidation
            });

        }
        else if (passwordState.status === 401) {

            this.setState({
                disabled: false
            });

            if (this.props.history !== undefined) {
                this.props.history.push('/sessionout')
            }

        }
        else if (passwordState.status === 428) {

            this.setState({
                showResetPopup: true,
                popupMessage: passwordState.message,
                disabled: false
            });

        }
        else {

            toast.error(passwordState.message, {
                position: "top-right",
                draggablePercent: 60,
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false
            });

            this.setState({
                stepIndex: stepIndex,
                disabled: false
            });

        }
    }
    handleNext() {

        let _this = this
        // const { publicKey } = this.props
        // if (publicKey.status === 200) {
        //     const public_Key = publicKey.body.publickey;
        //     let encrypt = new JSEncrypt();
        //     encrypt.setPublicKey(public_Key);

        this.props.fetchPassword(this.state.userId)
        //}

        this.setState({
            disabled: true,
        })
        setTimeout(function () {
            _this.handleStepCount7()
        }, 1500)




    }
    handlePrev() {
        const { stepIndex } = this.state;

        if (stepIndex > 0) {
            this.setState({ stepIndex: stepIndex - 1 });
        }
    }
    handleStep1() {
        this.setState({ stepIndex: 2 });
    }

    render() {
        const { stepIndex } = this.state;


        return (
            <div>
                {this.state.showResetPopup && (
                    <SuccessPopup
                        message={this.state.popupMessage}
                        onClose={() => this.setState({ showResetPopup: false })}
                    />
                )}
                <ToastContainer
                    draggablePercent={60}
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable={false}
                    pauseOnHover
                />
                <div><DefaulNavbar /> </div>
                <div style={{ width: '100%', maxWidth: 700, margin: 'auto', marginTop: "80px" }}>
                    <Stepper activeStep={stepIndex} connector={<ArrowForwardIcon />}>
                        <Step className="step">
                            <StepLabel>Enter User Id</StepLabel>
                        </Step>

                        <Step className="step">
                            <StepLabel>Verify & Submit</StepLabel>
                        </Step>
                    </Stepper>

                    {this.getStepContent(stepIndex)}


                </div>
            </div>
        );
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ForgotPassword))


// WEBPACK FOOTER //
// ./src/components/forgotpassword/forgotPassword.jsx